import React from 'react';
import { Link, useLocation, useSearchParams } from 'react-router-dom';
import MarketingLayout from '../components/marketing/MarketingLayout';
import { useAuth } from '../context/AuthContext';

export default function PaymentSuccessPage() {
  const { currentUser } = useAuth();
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const paymentId =
    searchParams.get('paymentId') || location.state?.paymentId || '';
  const planLabel = location.state?.planLabel || searchParams.get('plan') || '';

  return (
    <MarketingLayout>
      <header className="mk-page-hero">
        <div className="mk-container">
          <span className="mk-eyebrow">Payment</span>
          <h1>Payment successful</h1>
          <p>Thank you. Your payment was recorded and portal access will unlock according to your plan.</p>
        </div>
      </header>

      <section className="mk-section">
        <div className="mk-container">
          <div className="mk-result-card">
            <div className="mk-result-icon is-success">
              <span className="material-symbols-outlined" style={{ fontSize: 36 }}>
                check_circle
              </span>
            </div>
            <h2>You&apos;re all set</h2>
            <p>
              {planLabel
                ? `Your ${planLabel} purchase completed successfully.`
                : 'Your purchase completed successfully.'}
            </p>
            {paymentId ? (
              <p>
                Reference ID: <strong>{paymentId}</strong>
              </p>
            ) : null}
            <div className="mk-inline-actions" style={{ justifyContent: 'center', marginTop: 24 }}>
              {paymentId && currentUser ? (
                <Link to={`/payment-confirmation/${paymentId}`} className="mk-btn mk-btn-primary">
                  View receipt
                </Link>
              ) : null}
              {currentUser ? (
                <Link to="/dashboard" className="mk-btn mk-btn-primary">
                  Go to dashboard
                </Link>
              ) : (
                <Link to="/login" className="mk-btn mk-btn-primary">
                  Sign in
                </Link>
              )}
              <Link to="/program" className="mk-btn mk-btn-secondary">
                GED Program
              </Link>
            </div>
          </div>
        </div>
      </section>
    </MarketingLayout>
  );
}
